import { Button } from 'antd'
import { useState } from 'react'

export function useCollapseButton(records: unknown[]) {
  const [keys, setKeys] = useState<string[]>([])
  return {
    activeKey: keys,
    onChange: (keys: string | string[]) => setKeys(keys as string[]),
    CollapseButton:
      keys.length > 0 && records.length > 0 ? (
        <Button style={{ marginTop: '1rem' }} onClick={() => setKeys([])}>
          Collapse All
        </Button>
      ) : null,
  }
}
